import { IconComponentsProps } from './types';

const ClosedWithErrorIcon = ({ fill = '#FF758F', ...props }: IconComponentsProps) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6574 8.00348C11.8792 7.37694 12 6.70257 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C6.70257 12 7.37694 11.8792 8.00348 11.6574C8.00117 11.6052 8 11.5527 8 11.5C8 9.567 9.567 8 11.5 8C11.5527 8 11.6052 8.00117 11.6574 8.00348Z"
      fill="black"
      fill-opacity="0.77"
    />
    <path
      d="M15 12C15 11.4067 14.8241 10.8266 14.4944 10.3333C14.1648 9.83994 13.6962 9.45543 13.1481 9.22836C12.5999 9.0013 11.9967 8.94189 11.4147 9.05765C10.8328 9.1734 10.2982 9.45912 9.87868 9.87868C9.45912 10.2982 9.1734 10.8328 9.05765 11.4147C8.94189 11.9967 9.0013 12.5999 9.22836 13.1481C9.45543 13.6962 9.83994 14.1648 10.3333 14.4944C10.8266 14.8241 11.4067 15 12 15C12.7954 14.9991 13.5579 14.6828 14.1204 14.1204C14.6828 13.5579 14.9991 12.7954 15 12ZM14 12C13.9981 12.3559 13.9002 12.7047 13.7166 13.0095L10.9905 10.2835C11.2953 10.0998 11.6441 10.0019 12 10C12.5303 10.0006 13.0386 10.2115 13.4136 10.5864C13.7885 10.9614 13.9994 11.4698 14 12ZM10 12C10.0019 11.6441 10.0998 11.2953 10.2835 10.9905L13.0095 13.7166C12.7047 13.9002 12.3559 13.9981 12 14C11.4698 13.9994 10.9614 13.7885 10.5864 13.4136C10.2115 13.0386 10.0006 12.5303 10 12Z"
      fill="#3B1B21"
    />
    <path
      d="M9 3.525L8.475 3L6 5.475L3.525 3L3 3.525L5.475 6L3 8.475L3.525 9L6 6.525L8.475 9L9 8.475L6.525 6L9 3.525Z"
      fill={fill}
    />
  </svg>
);
export default ClosedWithErrorIcon;
